import { axiosInstance as axios } from '../lib/axios';
import { pickClient } from '../lib/apimRoutes';
import Config from '../config/environments';
import { POST_LOCATION, LIST_LOCATION, LIST_LOCATION_BREADCRUMBS } from '../actionTypes/location';
import { viewsModelToModels } from '../mapper/location';
import updateState from './common/common';

export const getDataLocation = (data) => async (dispatch) => {
  const base = {
    type: LIST_LOCATION,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.LOCATION.URL}/${data.latitude}/${data.longitude}/${data.location}/${Config.LOCATION.END_URL}`;
  const client = pickClient('GET', url);

  client.get(url).then((response) => {
    base.payload = updateState(response);
    base.payload.data = viewsModelToModels(base.payload.data);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const getDataLocationBreadcrumbs = (data) => async (dispatch) => {
  const base = {
    type: LIST_LOCATION_BREADCRUMBS,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.LOCATION.URL}/${data.latitude}/${data.longitude}/${data.location}/${Config.LOCATION.END_URL}`;
  const client = pickClient('GET', url);

  client.get(url).then((response) => {
    base.payload = updateState(response);
    base.payload.data = viewsModelToModels(base.payload.data);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const getDataLocationWithoutPagination = () => async (dispatch) => {
  const base = {
    type: LIST_LOCATION,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.LOCATION.URL}?page=1&quantity=100`;

  axios.get(url).then((response) => {
    base.payload = updateState(response);
    base.payload.data = viewsModelToModels(base.payload.data);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const postDataLocation = (data) => async (dispatch) => {
  const base = {
    type: POST_LOCATION,
    payload: {},
    state: true,
    success: true,
  };

  const url = Config.LOCATION.URL;

  axios.post(url, data).then((response) => {
    base.payload = updateState(response);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};

export const putDataLocation = (data) => async (dispatch) => {
  const base = {
    type: POST_LOCATION,
    payload: {},
    state: true,
    success: true,
  };

  const url = `${Config.LOCATION.URL}/${data.uuid}`;

  axios.put(url, data).then((response) => {
    base.payload = updateState(response);
  }).catch((error) => {
    base.payload = (error);
  }).finally(() => {
    dispatch(base);
  });

  dispatch(base);
};
